import { wrapperBuilder } from './build';
wrapperBuilder
  .getVariablesRegisterInstance()
  .addVariable('vinculation', { startValue: undefined })
  .addVariable('vinculationApiInstance', { startValue: undefined });
